import ConfigurationWrapper from '../3modules/Config/ConfigurationWrapper'
import useConfiguration from '../../services/configPage/useConfiguration'
import ReferenceDataAccordion from '../3modules/Config/ReferenceDataAccordion'
import useReferenceDataConfiguration from '../../services/configPage/useReferenceDataConfiguration'

const ReferenceDataConfiguration = () => {
  const {
    onEditMode,
    setOnEditMode,
    isSnackbarOpen,
    setIsSnackbarOpen,
    isLoading,
    setIsLoading,
  } = useConfiguration()

  const {
    selectedReferenceType,
    setSelectedReferenceType,
    items,
    handleSave,
    handleCancel,
    addItem,
    updateItem,
    deleteItem,
  } = useReferenceDataConfiguration(onEditMode, setOnEditMode, setIsLoading, setIsSnackbarOpen)

  return (
    <ConfigurationWrapper
      header={'Edit Reference Data'}
      onEditMode={onEditMode}
      setOnEditMode={setOnEditMode}
      handleCancel={handleCancel}
      isSnackbarOpen={isSnackbarOpen}
      setIsSnackbarOpen={setIsSnackbarOpen}
      isLoading={isLoading}
      handleSave={handleSave}
    >
      <ReferenceDataAccordion
        onEditMode={onEditMode}
        selectedReferenceType={selectedReferenceType}
        setSelectedReferenceType={setSelectedReferenceType}
        items={items}
        addItem={addItem}
        updateItem={updateItem}
        deleteItem={deleteItem}
      />
    </ConfigurationWrapper>
  )
}

export default ReferenceDataConfiguration
